import React from 'react';
import { FieldArrayRenderProps, FormikContext, useFormikContext } from 'formik';
import { FormBuilderValues } from '../FormBuilder';
import { GetForm_vm_form_formItems_VOLUNTEER_FormItemMediaType as MediaFormItemType } from '../../__generated__/GetForm';
import { MediaTaskItemDialog } from '../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/dialogs/MediaTaskItemDialog';

interface Props {
  open: boolean;
  close: () => void;
  arrayHelpers: FieldArrayRenderProps;
  data: MediaFormItemType | null;
}

export const MediaFormItemDialog = (props: Props) => {
  const { open, close, arrayHelpers, data } = props;
  const formikContext = useFormikContext<FormBuilderValues>();

  const adaptedData = data
    ? ({
        ...data,
        taskItemId: data.formItemId,
        __typename: 'VOLUNTEER_TaskItemMediaType',
      } as any)
    : null;

  const adaptedContext: any = {
    ...formikContext,
    values: {
      ...formikContext.values,
      taskItems: formikContext.values.formItems,
    },
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => {
      if (field === 'taskItems') {
        const convertedByIdEntries = Object.entries(value.byId || {}).map(([key, item]: [string, any]) => {
          const { taskItemId, ...rest } = item;
          return [
            key,
            {
              ...rest,
              __typename: item.__typename?.replace('TaskItem', 'FormItem') || item.__typename,
              formItemId: taskItemId || key,
            },
          ];
        });

        const convertedValue = {
          ...value,
          byId: Object.fromEntries(convertedByIdEntries),
        };
        formikContext.setFieldValue('formItems', convertedValue, shouldValidate);
      } else {
        formikContext.setFieldValue(field, value, shouldValidate);
      }
    },
  };

  return (
    <FormikContext.Provider value={adaptedContext}>
      <MediaTaskItemDialog open={open} close={close} arrayHelpers={arrayHelpers} data={adaptedData} />
    </FormikContext.Provider>
  );
};
